import { ThemeDefault } from '@seddi/ui-kit';
import { seddiGradient } from './theme';


export const SeddiTheme = { ...(ThemeDefault) };
SeddiTheme.color.s1 = 'rgba(93, 127, 135, 1)';
SeddiTheme.color.s2 = 'rgba(124, 154, 160, 1)';
SeddiTheme.background = seddiGradient;
